import { api } from './client'
import type { Bucket } from '@/types'

export function fetchBuckets(scope: 'active' | 'user' | 'archived' | 'system' = 'active'): Promise<Bucket[] | Bucket | null> {
  return api.get(`/api/buckets?scope=${scope}`)
}

export async function fetchActivePriorityCount(bucketId: string): Promise<number> {
  const { count } = await api.get<{ count: number }>(`/api/buckets/${bucketId}/active-priority-count`)
  return count
}

export async function createBucket(
  data: Pick<Bucket, 'name' | 'color'> &
    Partial<Pick<Bucket, 'intention' | 'visionStatement' | 'targetAlloc' | 'icon' | 'description'>>,
): Promise<string> {
  const { id } = await api.post<{ id: string }>('/api/buckets', data)
  return id
}

export function updateBucket(id: string, data: Partial<Omit<Bucket, 'id' | 'createdAt' | 'isSystem'>>): Promise<void> {
  return api.patch(`/api/buckets/${id}`, data)
}

export function reorderBucket(id: string, beforeRank: number | null, afterRank: number | null): Promise<void> {
  return api.post(`/api/buckets/${id}/reorder`, { beforeRank, afterRank })
}

export function archiveBucket(id: string, priorityDisposition: string): Promise<void> {
  return api.post(`/api/buckets/${id}/archive`, { priorityDisposition })
}

export function restoreBucket(id: string): Promise<void> {
  return api.post(`/api/buckets/${id}/restore`)
}

export function permanentlyDeleteBucket(id: string): Promise<void> {
  return api.delete(`/api/buckets/${id}`)
}
